<template>
    <div class="c-welcome">
        <h1>{{ welcomeText }}</h1>
        wir führen dich in wenigen Schritten durch deine Schadensmeldung.
        <img :src="baseurl + image" class="c-welcome__image" />
        <div v-if="!$store.state.isLoggedIn">
            <b>Tipp:</b> Als eingeloggter Kunde werden dir manche Felder
            vorausgefüllt. Dadurch sparst du dir Zeit!
        </div>
        <ion-grid class="ion-text-center ion-margin-top">
            <ion-row>
                <ion-col v-if="!$store.state.isLoggedIn">
                    <ion-button
                        class="-round"
                        expand="block"
                        fill="outline"
                        @click="$router.push({ name: 'login' })"
                        >Zum Login</ion-button
                    >
                </ion-col>
                <ion-col>
                    <ion-button
                        class="-round"
                        expand="block"
                        @click="$emit('hide')"
                        >Weiter</ion-button
                    >
                </ion-col>
            </ion-row>
        </ion-grid>
    </div>
</template>

<script>
import { BASEURL } from "@/utils/globals";

export default {
    props: {
        welcomeText: {
            required: true,
            type: String,
        },
        mode: {
            required: true,
            type: String,
        },
    },
    data() {
        return {
            baseurl: BASEURL,
            image: "",
        };
    },
    mounted() {
        if (this.mode === "kfz") {
            this.image =
                "/content/dam/klickmal/me1ns/schadensmeldung/kfz/schadensmeldung_kollision-kfz.png";
        } else if (this.mode === "haushalt") {
            this.image =
                "/content/dam/klickmal/me1ns/schadensmeldung/haushalt/schadensmeldung_feuer.png";
        } else if (this.mode === "recht") {
            this.image =
                "/content/dam/klickmal/me1ns/schadensmeldung/recht/schadensmeldung_haftpflicht.png";
        } else if (this.mode === "sach") {
            this.image =
                "/content/dam/klickmal/me1ns/schadensmeldung/sach/schadensmeldung_hagel.png";
        } else if (this.mode === "krankenhaus") {
            this.image =
                "/content/dam/klickmal/me1ns/schadensmeldung/krankenhaus/schadensmeldung_spital.png";
        } else if (this.mode === "unfall") {
            this.image =
                "/content/dam/klickmal/me1ns/schadensmeldung/unfall/schadensmeldung_unfall.png";
        }
    },
};
</script>

<style lang="scss" scoped>
.c-welcome {
    &__image {
        display: block;
        // padding: 20px;
        margin: auto;
        max-height: 50vh;
    }
}
</style>
